import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { Icon } from '@tesla/design-system-react';
import { iconPlus } from '@tesla/design-system-icons';
import classnames from 'classnames';
import styles from './styles.module.css.js';

var uploaderPropTypes = {
  /** Callback triggered on dropzone interaction */
  onDrop: PropTypes.func,
  /** Disable uploader */
  disabled: PropTypes.bool
};
var uploaderDefaultProps = {
  onDrop: function onDrop() {},
  disabled: false
};
var Uploader = function Uploader(_ref) {
  var onDrop = _ref.onDrop,
    disabled = _ref.disabled;
  var dropzoneRef = /*#__PURE__*/React.createRef();
  var handleDrop = function handleDrop(files) {
    onDrop(files);
  };
  return /*#__PURE__*/React.createElement(Dropzone, {
    onDrop: handleDrop,
    multiple: true,
    ref: dropzoneRef,
    disabled: disabled
  }, function (_ref2) {
    var getRootProps = _ref2.getRootProps,
      getInputProps = _ref2.getInputProps;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", _extends({}, getRootProps(), {
      className: styles.Container
    }), /*#__PURE__*/React.createElement("input", _extends({
      "aria-hidden": "true",
      title: "multi-photo-uploader-file-input"
    }, getInputProps())), /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.DropArea, _defineProperty({}, styles.Disabled, disabled))
    }, /*#__PURE__*/React.createElement(Icon, {
      data: iconPlus,
      "aria-hidden": "true",
      focusable: "false",
      className: styles.PlusIcon
    }))));
  });
};

// Binding proptypes
Uploader.propTypes = uploaderPropTypes;
Uploader.defaultProps = uploaderDefaultProps;

export { Uploader as default };
